import { showToast } from "./utils/toast";

const SECTION = "[data-personalize]";

const sectionOf = (el: Element): HTMLElement | null => el.closest<HTMLElement>(SECTION);

function setMode(section: HTMLElement, mode: "view" | "edit"): void {
  const view = section.querySelector<HTMLElement>("[data-pm-view]");
  const editor = section.querySelector<HTMLElement>("[data-pm-editor]");
  // No read view rendered (the legacy inline row) → the editor is all there is.
  if (!view || !editor) return;

  view.hidden = mode === "edit";
  editor.hidden = mode === "view";
}

// Repaint the read view from what was just submitted, so closing the editor does
// not leave the old message on screen until the drawer is reopened.
function syncView(section: HTMLElement, form: HTMLFormElement): void {
  const subject = form.querySelector<HTMLInputElement>('input[name="custom_message[subject]"]');
  const body = form.querySelector<HTMLTextAreaElement>('textarea[name="custom_message[body]"]');
  const checkedSeq = form.querySelector<HTMLInputElement>('input[name="custom_message[sequence_id]"]:checked');

  const subjectEl = section.querySelector<HTMLElement>("[data-pm-subject]");
  if (subjectEl && subject) subjectEl.textContent = subject.value;

  const bodyEl = section.querySelector<HTMLElement>("[data-pm-body]");
  if (bodyEl && body) {
    // Read through summernote where it is mounted — the textarea itself only
    // catches up on submit.
    const code = $(body).summernote ? ($(body).summernote("code") as string) : body.value;
    bodyEl.innerHTML = code || body.value;
  }

  const seqEl = section.querySelector<HTMLElement>("[data-pm-seq]");
  const seqName = checkedSeq?.dataset.seqName;
  if (seqEl && seqName) {
    seqEl.textContent = seqName;
    seqEl.title = seqName;
  }

  // It is a saved CustomMessage from here on, whatever it started as.
  const stateEl = section.querySelector<HTMLElement>("[data-pm-state]");
  if (stateEl) {
    stateEl.textContent = "Personalized";
    stateEl.classList.add("on");
  }
}

export function initCandidatePersonalize(): void {
  $(document)
    .off("click.pmEdit")
    .on("click.pmEdit", "[data-pm-edit]", function (this: HTMLElement) {
      const section = sectionOf(this);
      if (!section) return;
      setMode(section, "edit");
      section.querySelector<HTMLElement>("[data-pm-editor]")?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });

  $(document)
    .off("click.pmCancel")
    .on("click.pmCancel", "[data-pm-cancel]", function (this: HTMLElement) {
      const section = sectionOf(this);
      if (section) setMode(section, "view");
    });

  $(document)
    .off("ajax:beforeSend.pm")
    .on("ajax:beforeSend.pm", `${SECTION} form`, function () {
      showToast("Saving message…", "pending", 0);
    });

  // rails-ujs fires these on the remote form. create.js.erb / update.js.erb still
  // run and re-render the list row; the feedback lives here so both the drawer and
  // the inline row report a save the same way.
  $(document)
    .off("ajax:success.pm")
    .on("ajax:success.pm", `${SECTION} form`, function (this: HTMLFormElement) {
      const section = sectionOf(this);
      if (section) {
        syncView(section, this);
        setMode(section, "view");
      }
      // 2.5s: long enough to read after the row behind the drawer re-renders.
      showToast("Personalized message saved", "success", 2500);
    });

  $(document)
    .off("ajax:error.pm")
    .on("ajax:error.pm", `${SECTION} form`, function (this: HTMLFormElement, e: JQuery.TriggeredEvent) {
      const xhr = (e.originalEvent as CustomEvent | undefined)?.detail?.[2] as XMLHttpRequest | undefined;
      const status = xhr?.status ? ` (${xhr.status})` : "";
      showToast(`Could not save the message${status}`, "error", 4000);
    });
}
